import React, {
    useState,useEffect, useContext, useCallback, useMemo
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalNextProvider, Tooltip } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { useAuthentication } from 'gw-digital-auth-react';
import { EntityUtil } from 'gw-portals-util-js';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { PolicyChange, messages as commonMessage } from 'gw-capability-policychange-common-react';
import { messages as platformMessages } from 'gw-platform-translations';
import metadata from './VehiclesPage.metadata.json5';
import styles from '../../BAPolicyChange.module.scss';
import messages from './VehiclesPage.messages';

const unassignedDrivers = 'lobData.businessAuto.coverables.unassignedDrivers';
const unassignedVehicles = 'lobData.businessAuto.coverables.unassignedVehicles';
const drivers = 'lobData.businessAuto.coverables.drivers';
const vehicles = 'lobData.businessAuto.coverables.vehicles';

function MetadataTooltip({ children, ...rest }) {
    const translator = useContext(TranslatorContext);
    const child = Array.isArray(children) ? children[0] : children;
    let id = children[0].key.replace(/[0-9]/g, '')
    const message = (id == 'substituteContainer') ? translator(messages.substituteVehicle) : translator(messages.atleastOneVehicle)

    return (
        <Tooltip {...rest} content={message}>
            {child}
        </Tooltip>
    );
}

MetadataTooltip.propTypes = {
    children: PropTypes.shape({}).isRequired
};
function VehiclesPage(props) {
    const translator = useContext(TranslatorContext);
    const [vehiclePath, setVehiclePath] = useState('');
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const [selectedVehicle, setSelectedVehicle] = useState({});
    const { wizardData, updateWizardData, wizardSnapshot } = props;
    const { submissionVM } = wizardData;
    const [isVmIntitialized, updateIsVmInitialized] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isReplace, setIsReplace] = useState(false);
    const [replaceData, setReplaceData] = useState({});
    const {
        onValidate,
        initialValidation,
        isComponentValid,
        disregardFieldValidation
    } = useValidation('BAPolicyChangeVehiclePage');
    const { authHeader } = useAuthentication();
    const [isVinEditMode, setIsVinEditMode] = useState(false);
    const [previousData, setPreviousData] = useState({});
    const [isPageInitialised, updateIsPageInitialised] = useState(false);
    const [garageLocationDetailsValidation, updategarageLocationDetailsValidation] = useState(false);

    useEffect(() => {
        if (!isPageInitialised) {
            updateIsPageInitialised(true);
        }
    }, [ isPageInitialised, submissionVM]);

    const cleanUnassigned = useCallback(() => {
        const unassignedVehiclesList = _.get(submissionVM.value, unassignedVehicles);
        const unassignedDriversList = _.get(submissionVM.value, unassignedDrivers);
        if (!unassignedDriversList || unassignedDriversList.length === 0) {
            _.set(submissionVM, 'lobData.businessAuto.coverables.value.unassignedDrivers', []);
        }
        if (!unassignedVehiclesList || unassignedVehiclesList.length === 0) {
            _.set(submissionVM, 'lobData.businessAuto.coverables.value.unassignedVehicles', []);
        }
    }, [submissionVM]);

    const toggleDriverAssignment = useCallback(
        (driver, vehicle) => {
            if (
                submissionVM.value.lobData.businessAuto.coverables.isDriverAssigned(driver, vehicle)
            ) {
                submissionVM.value.lobData.businessAuto.coverables.removeDriverAssignment(
                    driver,
                    vehicle
                );
            } else {
                submissionVM.value.lobData.businessAuto.coverables.assignDriver(driver, vehicle);
            }
            submissionVM.value.updateUnAssignedMapping();
            updateWizardData(wizardData);
        },
        [submissionVM, updateWizardData, wizardData]
    );

    const showUniqueVinModal = useCallback(
        (duplicateVehicleArray) => {
            return ModalNextProvider.showAlert({
                title: messages.baVehicleNotUniqueTitle,
                message: translator(messages.baVinMatch, {
                    vinMatchedVehicle: duplicateVehicleArray[0].displayName
                        ? duplicateVehicleArray[0].displayName
                        : duplicateVehicleArray[0]?.make + ' ' + duplicateVehicleArray[0]?.model + ' ' + duplicateVehicleArray[0]?.year
                }),
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: platformMessages.ok
            }).catch(_.noop);
        },
        [translator]
    );

    const uniqueVin = useCallback(() => {
        let vincheckerror = false;
        const vehicleListArray = _.get(
            submissionVM.value,
            'lobData.businessAuto.coverables.vehicles'
        );
        const vehicleListWithVINData = vehicleListArray?.filter((vl) => vl.vin !== undefined)
        const groupedVehicles = _.groupBy(vehicleListWithVINData, (vehicle) => {
            return vehicle.vin;
        });
        Object.keys(groupedVehicles).forEach((vehicle) => {
            if (groupedVehicles[vehicle].length > 1) {
                showUniqueVinModal(groupedVehicles[vehicle]);
                vincheckerror = true;
                return false;
            }
            return true;
        });
        return vincheckerror;
    }, [showUniqueVinModal, submissionVM.value]);

    const showVehicleDetails = useCallback((vehicle, index) => {
        if (vehicle.delivery_EY === undefined) {
            vehicle.useOfVehicle_EY = undefined;
        }
        vehicle.isValidationRequired = true;
        setIsEdit(true);
        setVehiclePath(`lobData.businessAuto.coverables.vehicles.children[${index}].value`);
        setSelectedVehicle(vehicle);
    }, []);

    const removeVehicle = useCallback(
        (index) => {
            ModalNextProvider.showConfirm({
                title: messages.removeVehicleTitle,
                message: messages.removeVehicleDescription,
                status: 'warning',
                icon: 'mi-error-outline'
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    submissionVM.lobData.businessAuto.coverables.vehicles.value.splice(index,1)
                    disregardFieldValidation(`vehicle${index}`);
                    wizardData.submissionVM = submissionVM;  
                    updateWizardData(wizardData);
                    return true;
                }, _.noop
            );
        },
        [disregardFieldValidation, submissionVM, updateWizardData]
    );

    const deleteVehicle = useCallback(
        (index) => {
            submissionVM.lobData.businessAuto.coverables.vehicles.value.splice(index,1)
            disregardFieldValidation(`vehicle${index}`);
            wizardData.submissionVM = submissionVM;  
            updateWizardData(wizardData);
        },
        [disregardFieldValidation, submissionVM.value, updateWizardData, wizardData]
    );

    const getDriverFromList = useCallback((driversList, VehicleDriverID) => {
        const [, driverID] = VehicleDriverID.split('_');
        return driversList.value.find((driver) => driver.fixedId === Number(driverID));
    }, []);

    const handleValueChange = useCallback(
        (value, vehicle, driversList) => {
            if (
                vehicle.tempID === selectedVehicle.tempID
                || vehicle.fixedId === selectedVehicle.fixedId
            ) {
                if (value.length) {
                    const vehicleID = selectedVehicle.fixedId || selectedVehicle.tempID;
                } else {
                }
            }
        },
        [selectedVehicle, cleanUnassigned, submissionVM, toggleDriverAssignment, getDriverFromList]
    );

    const unassignedVehiclesOverrides = useCallback(() => {
        const unassignedVehiclesList = _.get(submissionVM.value, unassignedVehicles);
        let overrides = [];
        if (!_.isEmpty(unassignedVehiclesList)) {
            overrides = unassignedVehiclesList.map((vehicle, index) => {
                return {
                    [`errorNotificationVehicle${index}`]: {
                        message: translator(commonMessage.noVehicleError, {
                            vehicle: vehicle.getDisplayName()
                        }),
                        visible: true
                    }
                };
            });
        }
        return Object.assign({}, ...overrides);
    }, [translator, submissionVM]);

    const unassignedDriversOverrides = useCallback(() => {
        const unassignedDriversList = _.get(submissionVM.value, unassignedDrivers, []);
        let overrides = [];
        if (!_.isEmpty(unassignedDriversList)) {
            overrides = unassignedDriversList.map((driver, index) => {
                return {
                    [`errorNotificationDriver${index}`]: {
                        message: translator(commonMessage.noDriverError, {
                            driver: driver.getDisplayName()
                        }),
                        visible: true
                    }
                };
            });
        }
        return Object.assign({}, ...overrides);
    }, [translator, submissionVM]);

    const updateSubmission = (_submissionVM) => {
        const newSubmissionVMClone = viewModelService.clone(_submissionVM);
        wizardData.submissionVM = newSubmissionVMClone;  
        updateWizardData(wizardData);
    }

    const hideVehicleDetails = useCallback(
        (vehicleList, vehicle, index) => {

            if(isReplace || isEdit){
                const prevValue = _.get(
                    wizardSnapshot,
                    `submissionVM.lobData.businessAuto.coverables.vehicles.children.${index}`
                )
                if(!_.isUndefined(prevValue)){
                    _.set(
                        submissionVM,
                        `lobData.businessAuto.coverables.vehicles.children[${index}].value`,
                        prevValue.value
                    ); 
                } else {
                    _.set(
                        submissionVM,
                        `lobData.businessAuto.coverables.vehicles.children[${index}].value`,
                        previousData
                    ); 
                }
                 
                submissionVM.lobData.businessAuto.coverables.vehicleDrivers.children.forEach((v) => {
                    if(v.vehicleTempID.value == replaceData.current){
                        v.vehicleID = replaceData.previous,
                        v.vehicleTempID = undefined
                    }
                });
                disregardFieldValidation(`vehicle${index}`);
                setReplaceData({});            
                setVehiclePath('');
                setIsReplace(false);
                setIsEdit(false);
                updateWizardData(wizardData);
                return
            }
            // if(isEdit){
            //     setVehiclePath('');
            //     setIsEdit(false);
            //     return
            // }
            if (_.get(vehicleList.value[index], 'publicID')) {
                const prevValue = _.get(
                    wizardSnapshot,
                    'submissionVM.lobData.businessAuto.coverables.vehicles.children'
                ).find(
                    (vehicle) => vehicle.value.publicID === _.get(vehicleList.value[index], 'publicID')
                );
                _.set(
                    submissionVM,
                    `lobData.businessAuto.coverables.vehicles.children[${index}].value`,
                    prevValue.value
                );
                updateWizardData(wizardData);
            }
            else{
                deleteVehicle(index);
            }
            disregardFieldValidation(`vehicle${index}`);
            setVehiclePath('');
        },
        [
            deleteVehicle,
            disregardFieldValidation,
            isComponentValid,
            submissionVM,
            updateWizardData,
            wizardData,
            wizardSnapshot
        ]
    );

    const saveVehicleDetails = () => {
        setIsEdit(false);
        setIsReplace(false);
        setVehiclePath('');
    }

    const garagelocationValidation = useCallback((valid) => {
        updategarageLocationDetailsValidation(valid);
    }, [updategarageLocationDetailsValidation]);

    const vehicleOverrides = useMemo(() => {
        const availableVehiclePath = 'lobData.businessAuto.coverables.vehicles.children';
        const vehiclesList = _.get(submissionVM, vehicles, []);
        const driversList = _.get(submissionVM, drivers, []);
        let overrides = [];
        if (!_.isEmpty(vehiclesList)) {
            overrides = vehiclesList.value.map((vehicle, index) => {
                const modelName = _.get(vehicle, 'make')
                    ? `${_.get(vehicle, 'make')} ${_.get(vehicle, 'model')}`
                    : '';
                const yearData = _.get(vehicle, 'year') || '';
                const driversInfo = driversList.value.map((driver) => {
                    return {
                        code: `${vehicle.fixedId || vehicle.tempID}_${driver.fixedId}`,
                        name: driver.displayName
                    };
                });
                return {
                    [`baVehicleContainer${index}`]: {
                        visible: `${availableVehiclePath}[${index}].value` === vehiclePath
                    },
                    [`vehicle${index}`]:{
                        submissionVM: submissionVM,
                        updateWizardData: updateSubmission,
                        isPolicyChange: true,
                        authHeader: authHeader,
                        setIsVinEditMode: setIsVinEditMode,
                        isReplace: isReplace,
                        locationValidation: (valid) => { garagelocationValidation(valid); }

                    },
                    [`baVehicleSectionModelId${index}`]: {
                        value: modelName || translator(messages.baNewVehicle),
                        className: styles.vehicleMakeModelLabel
                    },
                    [`baVehicleSectionYearId${index}`]: {
                        value: yearData || ' '
                    },
                    [`baVehicleSectionTrashId${index}`]: {
                        disabled:
                            vehiclesList.length === 1
                            || (`${availableVehiclePath}[${index}].value` !== vehiclePath
                                && !isComponentValid) || isEdit,
                        visible: `${availableVehiclePath}[${index}].value` != vehiclePath, 
                        onClick: () => {
                            removeVehicle(index);
                        }
                    },
                    [`baVehicleSectionEditId${index}`]: {
                        disabled:
                            `${availableVehiclePath}[${index}].value` !== vehiclePath
                            && !isComponentValid || isEdit,
                        visible: `${availableVehiclePath}[${index}].value` !== vehiclePath,
                        onClick: () => {
                            showVehicleDetails(vehicle, index);
                        }
                    },
                    [`cancelBtnId${index}`]: {
                        onClick: () => {
                            hideVehicleDetails(vehiclesList, vehicle, index);
                        } 
                    },
                    [`saveBtnId${index}`]: {
                        disabled: (`${availableVehiclePath}[${index}].value` == vehiclePath) && vehiclesList.children[index].aspects.subtreeValid !== true,
                        onClick: () => {
                            saveVehicleDetails();
                        }
                    },
                    [`baVehicleSubstitute${index}`]: {
                        disabled: `${availableVehiclePath}[${index}].value` == vehiclePath && !isComponentValid || (isEdit && (`${availableVehiclePath}[${index}].value` !== vehiclePath)),
                        onClick: () => {
                            replaceVehicle(index);
                        }
                    }
                };
            });
        }
        return Object.assign({}, ...overrides);
    }, [
        submissionVM,
        vehiclePath,
        translator,
        isComponentValid,
        removeVehicle,
        showVehicleDetails,
        handleValueChange,
        isVinEditMode,
        setIsVinEditMode
    ]);


    const setDefaultNewEntry = useCallback(() => {
        const accountHolder = submissionVM.baseData.account.accountHolder.value;
        const vehicleObj = {
            licenseState: accountHolder.primaryAddress.state,
            tempID: EntityUtil.nextId(),
            //primaryUse: 'pleasure',
            vehicleType: 'PrivatePassenger_EY',
            //vehicleNumber: submissionVM.lobData.businessAuto.coverables.vehicles.length > 0 ? submissionVM.lobData.businessAuto.coverables.vehicles.length + 1 : 1,
            purchasePrice: {},
            isValidationRequired : true,
            resetVehicleGroups_EY : true,
            rateAsOfDate : submissionVM.baseData.effectiveDate.value
        };
        const { _xCenter, _dtoName } = submissionVM.lobData.businessAuto.coverables.vehicles;
        const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
        submissionVM.lobData.businessAuto.coverables.vehicles.pushElement(vehicleVM);
        setSelectedVehicle(vehicleVM);
    }, [submissionVM]);

    const onAddNew = useCallback(() => {
        setDefaultNewEntry();
        const vehicleIndex = submissionVM.lobData.businessAuto.coverables.vehicles.length - 1;
        setVehiclePath(`lobData.businessAuto.coverables.vehicles.children[${vehicleIndex}].value`);
        updateWizardData(wizardData);

    }, [setDefaultNewEntry, submissionVM]);

    const onNext = useCallback(async () => {
        if (!uniqueVin()) {
            // if (!submissionVM.value.validate()) {
            //     // re-render the component, if vehicles aren't mapped to drivers
            //     updateWizardData(wizardData);
            //     return false;
            // }
            //submissionVM.value.beforeSave();
            const policyChangeResponse = await EndorsementService.saveEndorsement(
                [submissionVM.value],
                authHeader
            );
            submissionVM.value = new PolicyChange(policyChangeResponse);
            cleanUnassigned();
            return wizardData;
        }
        return false;
    }, [
        EndorsementService,
        uniqueVin,
        submissionVM,
        authHeader,
        cleanUnassigned,
        wizardData,
        updateWizardData
    ]);

    const replaceVehicle = (index) => {
        setIsReplace(true);
        const prevVehicle = submissionVM.lobData.businessAuto.coverables.vehicles.value[index];
        setPreviousData(prevVehicle);
        const accountHolder = submissionVM.baseData.account.accountHolder.value;
        const vehicleObj = {
            licenseState: accountHolder.primaryAddress.state,
            purchasePrice: {},
            isValidationRequired : true,
            vehicleSubstituted_EY: true,
            tempID: EntityUtil.nextId(),
            garagedAt: _.get(prevVehicle, 'garagedAt'),
            annualMileage: _.get(prevVehicle, 'annualMileage'),
            rateAsOfDate: prevVehicle.rateAsOfDate ? prevVehicle.rateAsOfDate : submissionVM.baseData.periodStartDate.value,
            primaryUse: _.get(prevVehicle, 'primaryUse'),
            businessPercentage: _.get(prevVehicle, 'businessPercentage'),
            commutingMiles: _.get(prevVehicle, 'commutingMiles'),
            vehicleType: _.get(prevVehicle, 'vehicleType'),
            specialFarmUse: _.get(prevVehicle, 'specialFarmUse'),
            commercialUse : _.get(prevVehicle, 'commercialUse'),
            usExposure: _.get(prevVehicle, 'usExposure'),
            usExposurePercent : _.get(prevVehicle, 'usExposurePercent'),
            //vehicleSubstituted_EY: _.get(prevVehicle, 'vehicleSubstituted_EY'),
            vehicleNumber : _.get(prevVehicle, 'vehicleNumber'),
            commuteDaysPerWeek_EY : _.get(prevVehicle, 'commuteDaysPerWeek_EY'),
            resetVehicleGroups_EY : true
        };
        const { _xCenter, _dtoName } = submissionVM.lobData.businessAuto.coverables.vehicles;
        const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);        
        submissionVM.lobData.businessAuto.coverables.vehicles.value[index] = vehicleVM.value;
        submissionVM.lobData.businessAuto.coverables.vehicleDrivers.children.forEach((v) => {
            if(v.vehicleID.value == prevVehicle.fixedId){
                v.vehicleID.value = undefined,
                v.vehicleTempID.value = vehicleVM.tempID.value
            }
        });
        setReplaceData({previous: prevVehicle.fixedId, current: vehicleVM.tempID.value});
        setVehiclePath(`lobData.businessAuto.coverables.vehicles.children[${index}].value`);
        setSelectedVehicle(vehicleVM);
        wizardData.submissionVM = submissionVM;  
        updateWizardData(wizardData);
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onAddVehicleClick: onAddNew,
            onValidate: onValidate
        },
        resolveComponentMap: {
            tooltipcomponent: MetadataTooltip
        }
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        addVehicle: {
            disabled: !isComponentValid
        },
        ...vehicleOverrides,
        ...unassignedVehiclesOverrides(),
        ...unassignedDriversOverrides()
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [submissionVM, overrideProps]
    );
    const handleModelChange = useCallback(
        (newModel) => {
            updateWizardData({
                ...wizardData,
                submissionVM: newModel
            });
        },
        [updateWizardData, wizardData]
    );
    if (!isVmIntitialized) {
        updateWizardData(wizardData);
        updateIsVmInitialized(true);
        cleanUnassigned();
        return null;
    }
    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            disablePrevious={isEdit}
            skipWhen={initialValidation}
            cancelLabel={(appConfig.persona === 'policyholder' ? commonMessage.cancelAllChanges : commonMessage.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={handleModelChange}
                onValidationChange={onValidate}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                resolveValue={readValue}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

VehiclesPage.propTypes = wizardProps;
export default VehiclesPage;
